var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilledPersonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24pt",
    height: "24pt",
    viewBox: "0 0 22 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(244,67,54)",
      fillRule: "nonzero",
      fill: "rgb(244,67,54)",
      fillOpacity: 1
    },
    d: "M 13.617188 5.203125 C 13.617188 7.410156 11.773438 9.199219 9.5 9.199219 C 7.226562 9.199219 5.382812 7.410156 5.382812 5.203125 C 5.382812 2.992188 7.226562 1.203125 9.5 1.203125 C 11.773438 1.203125 13.617188 2.992188 13.617188 5.203125 Z M 13.617188 5.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(244,67,54)",
      fillRule: "nonzero",
      fill: "rgb(244,67,54)",
      fillOpacity: 1
    },
    d: "M 9.5 18.398438 C 4.265625 18.398438 0.0195312 14.28125 0.0195312 9.199219 C 0.0195312 4.117188 4.265625 -0.00390625 9.5 -0.00390625 C 14.734375 -0.00390625 18.976562 4.117188 18.976562 9.199219 C 18.972656 14.277344 14.730469 18.394531 9.5 18.398438 Z M 9.5 0.125 C 4.335938 0.125 0.152344 4.1875 0.152344 9.199219 C 0.152344 14.210938 4.335938 18.273438 9.5 18.273438 C 14.660156 18.273438 18.84375 14.210938 18.84375 9.199219 C 18.839844 4.191406 14.660156 0.128906 9.5 0.125 Z M 9.5 0.125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(244,67,54)",
      fillRule: "nonzero",
      fill: "rgb(244,67,54)",
      fillOpacity: 1
    },
    d: "M 9.5 10.339844 C 6.382812 10.339844 3.46875 11.839844 1.71875 14.339844 C 3.46875 16.839844 6.382812 18.335938 9.5 18.335938 C 12.613281 18.335938 15.527344 16.839844 17.28125 14.339844 C 15.527344 11.839844 12.613281 10.339844 9.5 10.339844 Z M 9.5 10.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(244,67,54)",
      fillRule: "nonzero",
      fill: "rgb(244,67,54)",
      fillOpacity: 1
    },
    d: "M 9.5 18.398438 C 6.363281 18.398438 3.429688 16.894531 1.664062 14.375 L 1.636719 14.339844 L 1.664062 14.300781 C 3.429688 11.785156 6.363281 10.277344 9.5 10.277344 C 12.636719 10.277344 15.570312 11.785156 17.335938 14.300781 L 17.359375 14.339844 L 17.335938 14.375 C 15.570312 16.894531 12.636719 18.398438 9.5 18.398438 Z M 1.796875 14.339844 C 3.539062 16.800781 6.421875 18.273438 9.5 18.273438 C 12.578125 18.273438 15.457031 16.800781 17.203125 14.339844 C 15.457031 11.875 12.578125 10.402344 9.5 10.402344 C 6.421875 10.402344 3.539062 11.875 1.796875 14.339844 Z M 1.796875 14.339844 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledPersonIcon);
export default __webpack_public_path__ + "static/media/filledPersonIcon.86e3a7d3.svg";
export { ForwardRef as ReactComponent };